import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';

export interface ToastData {
  isShow?: boolean;
  severity?: string;
  errors?: {[key:string]: string};
  summary?: string;
  detail?: string;
  life?: number;
}

interface AppContextValues {
  toastData: ToastData | null;
  showToast:  React.Dispatch<React.SetStateAction<ToastData | null>>;
}

export const AppContext = createContext({});
const AppProvider = ({ children }: { children: ReactNode }) => {
  const [toastData, showToast] = useState<ToastData | null>(null);
  return (
    // this is the provider providing state
    <AppContext.Provider value={{ toastData, showToast }}>
      {children}
    </AppContext.Provider>
  );
};

export function useAppContext(): AppContextValues {
  return useContext(AppContext) as AppContextValues;
}

export default AppProvider;
